<template>
  <span class="message-body-mentions">
    <span v-for="(part, idx) in parts" :key="idx">
      <template v-if="part.type === 'text'">{{ part.value }}</template>
      <span v-else-if="plain"
            class="mention-chip mention-chip--plain"
            :class="{ 'mention-chip--plain-clickable': !!config(part.mentionType).route }"
            @click.stop="onClick(part)">
        <b-icon :icon="config(part.mentionType).icon" class="mention-chip-icon mention-chip-icon--plain"></b-icon>{{ part.label }}
      </span>
      <span v-else
            class="mention-chip"
            :class="{ 'mention-chip--clickable': !!config(part.mentionType).route }"
            v-b-tooltip.hover
            :title="config(part.mentionType).label"
            @click.stop="onClick(part)">
        <b-icon :icon="config(part.mentionType).icon" class="mention-chip-icon"></b-icon>{{ part.label }}
      </span>
    </span>
  </span>
</template>

<script>
/**
 * Renderiza el body de un mensaje interceptando los tokens @[Label](tipo:id)
 * y mostrándolos como chips en vez de texto crudo. Único lugar que sabe
 * "cómo se ve una mención" — MessagesWidget.vue e inbox.vue solo usan
 * <message-body :body="..."/> en vez de reimplementar el parseo/estilo cada
 * uno. El tipo (Cliente/Proveedor/etc.) se ve al pasar el mouse, no compite
 * visualmente con el texto en reposo.
 */
import { parseMentionParts } from '@/handler/mentions'
import { getMentionableConfig } from '@/config/mentionable'

export default {
  name: 'MessageBody',
  props: {
    body: { type: String, default: '' },
    // true para la vista previa de una sola línea truncada (lista de
    // conversaciones): ahí el chip normal (inline-flex, por el ícono) hace
    // que Chrome directamente no pinte nada si no entra completo al aplicar
    // text-overflow:ellipsis. La variante "plana" es texto inline normal sin
    // ícono, sin color propio (hereda el de la fuente actual), así trunca
    // igual que el resto del texto.
    plain: { type: Boolean, default: false },
  },
  computed: {
    parts() {
      return parseMentionParts(this.body)
    },
  },
  methods: {
    config(type) {
      return getMentionableConfig(type)
    },
    onClick(part) {
      var cfg = this.config(part.mentionType)
      if (!cfg.route) return
      var params = {}
      params[cfg.routeParam] = part.mentionId
      this.$router.push({ name: cfg.route, params: params })
    },
  },
}
</script>

<style scoped>
.mention-chip {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-weight: 600;
  border-bottom: 1px dotted currentColor;
  line-height: 1;
}
.mention-chip--clickable {
  cursor: pointer;
}
.mention-chip--clickable:hover {
  border-bottom-style: solid;
}
.mention-chip-icon {
  font-size: 0.85em;
  margin-right: 3px;
  opacity: 0.75;
}
.mention-chip--plain {
  display: inline;
  color: inherit;
  border-bottom: 1px dotted currentColor;
}
.mention-chip--plain-clickable {
  cursor: pointer;
}
.mention-chip--plain-clickable:hover {
  border-bottom-style: solid;
}
.mention-chip-icon--plain {
  /* bootstrap-vue fuerza .b-icon.bi{display:inline-block}: un ícono
     inline-block es, igual que el inline-flex del chip normal, una caja
     atómica que "text-overflow:ellipsis" puede ocultar entera si no entra
     completa. Con inline vuelve a ser texto normal que se puede recortar. */
  display: inline !important;
  margin-right: 2px;
}
</style>
